<template>
    <div class="canvas" ref="canvas" :style="{width: `${roadWidth}px`, height: `${roadHeight}px`}"></div>
</template>

<script>
import * as PIXI from "pixi.js";
import { road } from "../utils";

export default {
    name: "road",

    props: {
        roadHeight: {
            type: Number,
            required: true
        },
        roadWidth: {
            type: Number,
            required: true
        },
        obstacles: {
            type: Array
        }
    },

    data() {
        return {
            //视图
            app: null,
            //小车缓存
            texture: null,
            //障碍物图片缓存
            obstacleTexture: null,
            //人缓存
            person: null,
            scale: 0,
            //障碍物缓存
            obstacleCarsAndPerson: []
        };
    },

    watch: {
        roadHeight() {
            if (this.$refs.canvas) {
                this.initCanvas();
            }
        }
    },

    created() {},

    methods: {
        calcPoints(height, width) {
            let topStep = width / 5;
            let bottomStep = width / 3;

            let paths = [];

            //道路线1
            paths.push([topStep, 0, 0, height]);

            //道路线2
            paths.push([topStep * 2, 0, bottomStep, height]);

            //道路线3
            paths.push([topStep * 3, 0, bottomStep * 2, height]);

            //道路线4
            paths.push([topStep * 4, 0, width, height]);

            return paths;
        },

        //画车道线
        drawRoads(paths, app) {
            if (Array.isArray(paths)) {
                for (let path of paths) {
                    const road = new PIXI.Graphics();

                    road.lineStyle(3, 0xc3c3f9, 1);
                    road.moveTo(path[0], path[1]);
                    road.lineTo(path[2], path[3]);

                    app.stage.addChild(road);
                }
            }
        },

        //添加当前车
        addCarToRoad(roadHeight, roadWidth, app) {
            const car = new PIXI.Sprite(this.texture);

            car.anchor.set(0);
            car.scale.set(0.5);

            let { width, height } = car;
            car.x = roadWidth / 2 - width / 2;
            car.y = this.scale * 20 - height / 2;

            app.stage.addChild(car);
        },

        //添加障碍物
        addObstaclesToRoad(item, app) {
            let { type, position, offset } = item;

            const img = new PIXI.Sprite(
                type === "Vehicle" ? this.obstacleTexture : this.person
            );

            img.anchor.set(0.5);

            let scale = 0.7 + (20 - offset) / 35;

            img.scale.set(scale);

            let { width, height } = img;

            let top = (20 - offset) * this.scale;
            let roadSlope =
                this.roadHeight /
                ((this.roadWidth * 3) / 10 - this.roadWidth / 6);
            let angle = (Math.atan(roadSlope) * 180) / Math.PI;

            if (position === "left") {
                img.x =
                    this.roadWidth / 6 + (this.roadHeight - top) / roadSlope;

                type === "Vehicle" && (img.angle = 90 - angle);
            } else if (position === "right") {
                img.x =
                    (this.roadWidth * 5) / 6 -
                    (this.roadHeight - top) / roadSlope;

                type === "Vehicle" && (img.angle = angle - 90);
            } else {
                img.x = this.roadWidth / 2;
            }
            img.y = top;

            this.obstacleCarsAndPerson.push(img);
            app.stage.addChild(img);
        },

        //初始化画布
        async initCanvas() {
            let wrapper = this.$refs.canvas;

            //比例尺
            this.scale = this.roadHeight / 35;

            this.app = new PIXI.Application({
                width: this.roadWidth,
                height: this.roadHeight,
                transparent: true
            });

            wrapper.appendChild(this.app.view);

            this.drawRoads(
                this.calcPoints(this.roadHeight, this.roadWidth),
                this.app
            );

            const loader = new PIXI.Loader();

            await loader
                .add("car", road.car)
                .add("person", road.person)
                .add("obstacleCar", road.obstacleCar);

            loader.load((loader, resources) => {
                this.person = resources.person.texture;
                this.obstacleTexture = resources.obstacleCar.texture;
                this.texture = resources.car.texture;
                this.addCarToRoad(this.roadHeight, this.roadWidth, this.app);
            });

            const ticker = PIXI.Ticker.shared;
            ticker.autoStart = false;
            ticker.stop();
            this.app.ticker.add(this.update);
        },

        update() {
            this.obstacleCarsAndPerson.forEach(item => {
                this.app.stage.removeChild(item);
            });
            this.obstacleCarsAndPerson = [];

            if (this.obstacles.length) {
                for (let item of this.obstacles) {
                    this.addObstaclesToRoad(item, this.app);
                }
            }
        }
    }
};
</script>

<style scoped>
.canvas {
    height: 100%;
    width: 100%;
}
</style>


